// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as I18next$LiveRoom from "../bindings/I18next.bs.js";
import * as PropSpread$LiveRoom from "./PropSpread.bs.js";
import * as SterlingTokens$LiveRoom from "../bindings/SterlingTokens.bs.js";
import * as SterlingTypography$LiveRoom from "../bindings/SterlingTypography.bs.js";

var tagStyles = Curry._1(Css.style, {
      hd: Css.width("fitContent"),
      tl: {
        hd: Css.height(Css.px(18)),
        tl: {
          hd: Css.display("inline"),
          tl: {
            hd: Css.paddingLeft(Css.px(8)),
            tl: {
              hd: Css.paddingRight(Css.px(8)),
              tl: {
                hd: Css.borderRadius(Css.px(2)),
                tl: {
                  hd: Css.whiteSpace("nowrap"),
                  tl: /* [] */0
                }
              }
            }
          }
        }
      }
    });

function LotTags$Tag(props) {
  var extraStyles = props.extraStyles;
  var extraStyles$1 = extraStyles !== undefined ? extraStyles : Curry._1(Css.style, /* [] */0);
  return React.createElement(PropSpread$LiveRoom.make, {
              data: {
                hd: {
                  TAG: /* TestId */1,
                  _0: "lotTag"
                },
                tl: /* [] */0
              },
              children: React.createElement(SterlingTypography$LiveRoom.Label12Medium.make, {
                    className: Curry._1(Css.merge, {
                          hd: tagStyles,
                          tl: {
                            hd: extraStyles$1,
                            tl: /* [] */0
                          }
                        }),
                    children: props.text
                  })
            });
}

var Tag = {
  make: LotTags$Tag
};

var stylesBasic = Curry._1(Css.style, {
      hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag)),
      tl: {
        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
        tl: /* [] */0
      }
    });

var stylesNoReserve = Curry._1(Css.style, {
      hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.alertTurq60_nohashtag)),
      tl: {
        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryWhite_nohashtag)),
        tl: /* [] */0
      }
    });

function LotTags(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t = match.t;
  return React.createElement("div", {
              className: Curry._1(Css.style, {
                    hd: Css.display("flex"),
                    tl: {
                      hd: Css.gridGap(Css.px(8)),
                      tl: /* [] */0
                    }
                  })
            }, Belt_Array.mapWithIndex(props.tags, (function (index, tag) {
                    if (tag !== undefined) {
                      if (tag) {
                        return React.createElement("div", {
                                    key: "lotParcelTag-" + String(index)
                                  }, React.createElement(LotTags$Tag, {
                                        text: tag._0,
                                        extraStyles: stylesBasic
                                      }));
                      } else {
                        return React.createElement("div", {
                                    key: "lotTag-" + String(index)
                                  }, React.createElement(LotTags$Tag, {
                                        text: Curry._1(t, "Common_noReserve"),
                                        extraStyles: stylesNoReserve
                                      }));
                      }
                    } else {
                      return null;
                    }
                  })));
}

var make = LotTags;

export {
  tagStyles ,
  Tag ,
  stylesBasic ,
  stylesNoReserve ,
  make ,
}
/* tagStyles Not a pure module */
